import React from 'react'

import './EmergencyContactInput.css'

// components
import InputField from '../../InputField/InputField.component'
import Checkbox from '../../Checkbox/Checkbox.component'

// mui
import { Grid, Paper, IconButton } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

export default function EmergencyContactInput({ prefix, handleChange, firstName, lastName, phone, isPrimary, handleRemove, errors }) {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                <div className='emergency-contact-input-row'>
                    <div className='emergency-contact-input-column'>
                        <InputField 
                            id={`${prefix}.firstName`}
                            type="text"
                            placeholder='First Name'
                            onChange={handleChange}
                            value={firstName}
                            isValid={errors['firstName']}
                        />
                    </div>
                    <div className='emergency-contact-input-column'>
                        <InputField 
                            id={`${prefix}.lastName`}
                            type="text"
                            placeholder='Last Name'
                            onChange={handleChange}
                            value={lastName}
                            isValid={errors['lastName']}
                        />
                    </div>
                </div>

                <div className='emergency-contact-input-row'>
                    <div className='emergency-contact-input-column'>
                        <InputField 
                            id={`${prefix}.phone`}
                            type="text"
                            placeholder='Phone'
                            onChange={handleChange}
                            value={phone}
                            isValid={errors['phone']}
                        />
                    </div>
                    <div className='emergency-contact-input-column'>
                        <Checkbox 
                        label={'Primary'}
                        type="text"
                        id={`${prefix}.isPrimary`}
                        isChecked={isPrimary}
                        handleChange={handleChange}
                        isValid={errors['isPrimary']}
                    />
                    </div>
                    
                    
                </div>
            </Paper>
        </Grid>
    </Grid>
        
    )
}